import { Link } from 'react-router-dom';
import { Clock, CheckCircle, Shield, Sparkles, ArrowRight, Armchair, Gamepad2, Briefcase, Heart, Wallet, Ruler } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function QuizPromoSection() {
  const icons = [
    { Icon: Armchair, label: 'Ergonómica' },
    { Icon: Gamepad2, label: 'Gaming' },
    { Icon: Briefcase, label: 'Ejecutiva' },
    { Icon: Heart, label: 'Lumbar' },
    { Icon: Wallet, label: 'Económica' },
    { Icon: Ruler, label: 'A Medida' },
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-background to-accent/30">
      <div className="container-wide">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary to-primary/80 p-8 md:p-12">
          {/* Background decorations */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-white" />
            <div className="absolute -left-10 -bottom-10 h-48 w-48 rounded-full bg-white" />
          </div>
          
          <div className="relative flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 rounded-full bg-white/20 px-3 py-1 mb-4">
                <Clock className="h-4 w-4 text-white" />
                <span className="text-sm font-medium text-white">3 minutos · Gratis</span>
              </div>
              
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Descubre tu silla ideal
              </h2>
              
              <p className="text-lg text-white/90 mb-6 max-w-xl">
                Responde unas preguntas sobre tu altura, peso, horas de trabajo y necesidades. 
                Te mostraremos qué tipo de silla puede ayudarte según tu perfil.
              </p>
              
              <ul className="flex flex-wrap justify-center lg:justify-start gap-4 mb-6 text-sm text-white/80">
                <li className="flex items-center gap-1.5">
                  <CheckCircle className="h-4 w-4" />
                  Personalizado
                </li>
                <li className="flex items-center gap-1.5">
                  <Shield className="h-4 w-4" />
                  Privado
                </li>
                <li className="flex items-center gap-1.5">
                  <Sparkles className="h-4 w-4" />
                  Sin compromiso
                </li>
              </ul>
              
              <Link to="/quiz-sillas">
                <Button size="lg" variant="secondary" className="gap-2">
                  Empezar el Quiz
                  <ArrowRight className="h-4 w-4" />
                </Button>
              </Link>
            </div>
            
            {/* Icon grid */}
            <div className="hidden lg:grid grid-cols-3 gap-4">
              {icons.map(({ Icon, label }) => (
                <div 
                  key={label}
                  className="flex flex-col items-center justify-center w-20 h-20 rounded-xl bg-white/10 backdrop-blur-sm"
                >
                  <Icon className="h-6 w-6 text-white mb-1" />
                  <span className="text-xs text-white/80">{label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
